import axios from "axios"
import config from "../config"

export const latency = (latency) => {
    return {
        type: "CHECKS_LATENCY",
        data: latency,
    }
}
export const startTest = (value) => {
    return {
        type: "START_TEST",
        data: value,
    }
}
export const startAudioTest = (value) => {
    return {
        type: "START_AUDIO_TEST",
        data: value,
    }
}

export const getList = () => dispatch => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}checks/list`)
            .then(response => {
                resolve(response.data)
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}